import { Record } from 'immutable';
import _ from 'lodash';

const properties = {
  id: String(),
  name: String(),
  state: String(),
  stateCode: String(),
  restrictToStateCode: false,
  country: String(),
  countryCode: String(),
  restrictToCountryCode: false,
  picture: String(),
  coordinates: [Number()],
  currencyCode: String(),
  region: String(),
  radius: Number(),
  public: Boolean(),
};

export default class Location extends Record(properties, 'Location') {
  public readonly id!: string;

  public readonly name!: string;

  public readonly state!: string;

  public readonly stateCode!: string;

  public readonly restrictToStateCode!: boolean;

  public readonly country!: string;

  public readonly countryCode!: string;

  public readonly restrictToCountryCode!: boolean;

  public readonly picture!: string;

  public readonly coordinates!: number[];

  public readonly currencyCode?: string;

  public readonly region?: string;

  public readonly radius?: number;

  public readonly public?: boolean;

  constructor(values: any = {}) {
    super(_.pick(values, Object.keys(properties)));
  }
}
